import { DocumentTextIcon } from '@heroicons/react/outline';

export function PdfFileIcon() {
  return <DocumentTextIcon className="h-full text-file-pdf-enabled" />;
}
